export default __webpack_public_path__ + "static/media/Flag_of_Pakistan.ffd6654c.svg";